/**
 * Created by Ning Jiang on 4/4/2017.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {IWixxGameModeChangedData} from "../gamemode/WixxGameMode";
import {WixxHelper} from "../utils/WixxHelper";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {WixxReelSymbol} from "../reelsymbol/WixxReelSymbol";
import {WixxGameConfig} from "../WixxGameConfig";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";

export class WixxReelController extends SpinReelController {

    private _boostedSymbols:string[] = [];

    constructor(reelId:number) {
        super(reelId);
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event:GameEvent) => this.onChangeMode(event.params[0]));
    }

    protected onChangeMode(data:IWixxGameModeChangedData):void {
        if(data.feature == null) {
            return;
        }

        if(data.feature === "BASE") {
            this._boostedSymbols = [];
            return;
        }

        this._boostedSymbols = WixxHelper.featureToSymbols(data.feature);

        if(!this.allSymbols || this._boostedSymbols.length === 0 || !data.updateBoostedSymbols) {
            return;
        }

        // To restore the boosted symbols when game started on restore.
        let symbol:WixxReelSymbol;
        for(let i:number = 0; i < this.allSymbols.length; i++) {
            symbol = <WixxReelSymbol>this.allSymbols[i]!;
            if(this._boostedSymbols.indexOf(symbol.symName) > -1) {
                symbol.replaceWith(`${symbol.symName}_boosted`, this._reelId);
            }
            if(this._boostedSymbols.indexOf("M2") > -1 && WixxHelper.isMidSymbol(symbol.symName)) {
                // https://github.com/nolimitcity/wixx/issues/54
                if(!(this._boostedSymbols.indexOf("M1") > -1 && symbol.symName.indexOf("M1") > -1)) {
                    symbol.playMultiplier(symbol.currentState!.keyword === WixxGameConfig.instance.SYMBOL_STATES.noWin!.keyword ? WixxGameConfig.instance.SYMBOL_MULTIPLIER_NO_WIN_ALPHA : 1, 0, 1);
                }
            }
        }
    }

    protected addNewSymbol(symName:string, state?:ISymbolStateConfig):StateReelSymbol {
        let hasMultiplier:boolean = false;
        if(this._boostedSymbols.indexOf("M2") > -1 && WixxHelper.isMidSymbol(symName)) {
            // https://github.com/nolimitcity/wixx/issues/54
            hasMultiplier = !(this._boostedSymbols.indexOf("M1") > -1 && symName === "M1");
        }

        if(this._boostedSymbols.indexOf(symName) > -1) {
            symName += "_boosted";
        }

        const symbol:WixxReelSymbol = <WixxReelSymbol>super.addNewSymbol(symName, state);

        if(hasMultiplier) {
            symbol.playMultiplier(1, 0, symbol.currentState!.keyword === GameConfig.instance.SYMBOL_STATES.spin.keyword ? 2 : 1);
        }

        return symbol
    }
}